import "./components/nav.js";
import "wa-mediabox";

// Get the current date and time
const currentDate = new Date();
const currentDay = currentDate.getDay(); // Sunday is represented as 0, Saturday as 6
const currentHour = currentDate.getHours();
const currentMinute = currentDate.getMinutes();

// Check if it's Sunday and between 9:45 AM and 11:00 AM
if (
  currentDay === 0 && // Checking if it's Sunday
  ((currentHour === 9 && currentMinute >= 30) ||
    (currentHour === 10 && currentMinute <= 59))
) {
  // Display the live stream
  let livestreamVideo = document.querySelector("#livestream-video");
  let recentVideo = document.querySelector("#most-recent-video");
  if (livestreamVideo) {
    livestreamVideo.classList.remove("hidden");
    livestreamVideo.classList.add("block");
  }

  if (recentVideo) {
    recentVideo.classList.remove("block");
    recentVideo.classList.add("hidden");
  }
}
